"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = __importDefault(require("vue"));
const Utils_1 = require("../../utils/Utils");
const DATA_DELETION_MODAL_CLOSE_KEY = "AboutDataDeletion";
exports.default = vue_1.default.extend({
    data() {
        return {
            borderImageUrl: 'url(images/game/common/img_dialog_frame.png)',
        };
    },
    methods: {
        aboutDataDeletionModalClose() {
            localStorage.setItem(DATA_DELETION_MODAL_CLOSE_KEY, '1');
            const modalEle = document.querySelector('#data-deletion-modal');
            modalEle.style.display = 'none';
        },
        aboutDataDeletionModalOpen() {
            const modalEle = document.querySelector('#data-deletion-modal');
            modalEle.style.display = 'flex';
        },
    },
    mounted() {
        const modalClose = localStorage.getItem(DATA_DELETION_MODAL_CLOSE_KEY);
        const isEventOutOfDate = Utils_1.Utils.isWithinPeriod('2023-09-01 00:00:00', '2099-12-31 23:59:59', 'Asia/Tokyo');
        if (modalClose === '1' || isEventOutOfDate) {
            const modalEle = document.querySelector('#data-deletion-modal');
            if (modalEle) {
                modalEle.style.display = 'none';
            }
        }
        if (isEventOutOfDate) {
            const bannerEle = document.querySelector('#info_title_data_deletion');
            if (bannerEle) {
                bannerEle.style.display = 'none';
            }
        }
    },
});
